import { render } from "./TermsSelector.vue?vue&type=template&id=17117ffa&lang=pug"
import script from "./TermsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsSelector.vue?vue&type=script&setup=true&lang=js"

import "./TermsSelector.vue?vue&type=style&index=0&id=17117ffa&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__